// Agences à plat ({ id, name, parent_id }, déjà triées par nom côté serveur) →
// treeData du TreeSelect. Une agence dont le parent n'est pas dans la liste
// remonte à la racine plutôt que de disparaître.
export const buildEntityTree = (entities = []) => {
  const nodes = new Map(
    entities.map((entity) => [entity.id, { value: entity.id, title: entity.name, children: [] }])
  );
  const roots = [];

  entities.forEach((entity) => {
    const node = nodes.get(entity.id);
    const parent = entity.parent_id !== entity.id ? nodes.get(entity.parent_id) : null;
    if (parent) parent.children.push(node);
    else roots.push(node);
  });

  // Feuilles sans `children` : le TreeSelect n'affiche alors pas de flèche d'ouverture.
  const prune = (list) =>
    list.map(({ children, ...node }) => (children.length ? { ...node, children: prune(children) } : node));

  return prune(roots);
};
